import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import LifestylePage from "@/pages/lifestyle/page";
import TrendPage from "@/pages/trend/page";
import DetailPage from "@/pages/detail/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import SiteLayout from "@/components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsPage /> },
      { path: "lifestyle", element: <LifestylePage /> },
      { path: "trend", element: <TrendPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;